import { createContext } from "react";
import { AuthConfig } from "../../api/Login";

/**
 * This provides the authentication config as fetched from the backend as a context.
 */
export const AuthConfigContext = createContext<AuthConfig>(undefined!);
